import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import {Sabko} from '../App';
import '../style/Formcom.css';

function Personal() {
  const navigate=useNavigate();
  const {state,dispatch}=useContext(Sabko);
  const[Value,setValue]=useState({})
  
  const changeVal=(e)=>{
    const name=e.target.name;
    const value=e.target.value;
    setValue((prev)=>({...prev,[name]:value}))

  }

  const submitPersoal=(e)=>{
    e.preventDefault();
    if(Object.keys(Value).length===0 && !state.User?.Personal){
      navigate('/') 
    }else{
      dispatch({type:"PERSONAL_DETAIL",payload:{...Value} });
      navigate('/') 
    }
  }
  return (
    <>
        <div className='main'>

        <form className='Homediv'>
            <div className='inputdiv'>
            <label htmlFor='name' className='inputLabel'>Name</label>
            <input type='text'  id='name' name='name'
             value={(Value.name)||((Value.name==="")?(""):(state.User?.Personal?.name) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>

            <div className='inputdiv'>
            <label htmlFor='address' className='inputLabel'>Address</label>
            <textarea rows='7' cols='7' id='address' name='address'  
            value={(Value.address)||((Value.address==="")?(""):(state.User?.Personal?.address) || (""))} 
              className='inputContent' style={{border: '1px solid gray'}}  onChange={changeVal}/>
            </div>

            <div className='inputdiv'>
            <label htmlFor='mail' className='inputLabel'>Email</label>
            <input type='email'  id='mail' name='mail'  
             value={(Value.mail)||((Value.mail==="")?(""):(state.User?.Personal?.mail) || (""))} 
              className='inputContent'  onChange={changeVal}/>
            </div>        

            <div className='inputdiv'>
            <label htmlFor='phone'  className='inputLabel'>Phone</label>
            <input type='tel' id='phone' name='phone'
             value={(Value.phone)||((Value.phone==="")?(""):(state.User?.Personal?.phone) || (""))} 
              className='inputContent'  onChange={changeVal}/> 
            </div>

            <div className='saveDiv'>
            <Button variant="contained" type='submit' className='saveButt' onClick={submitPersoal}>
            Save</Button>
            </div>

        </form>
        </div> 
    </>
  )
}

export default Personal